module.exports = __webpack_public_path__ + "img/schema.ab36f950.png";